export class SupplierRelaunchListView {
    id: number;
    companyName: string;
    lastName: string;
    firstName: string;
    phone: string;
    email: string;
    type: string; // "prospect" | "supplier"
    vendorName: string; // commercial: expert-role vendor, else last sales-assignation vendor

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.companyName = data?.companyName ?? '';
        this.lastName = data?.lastName ?? '';
        this.firstName = data?.firstName ?? '';
        this.phone = data?.phone ?? '';
        this.email = data?.email ?? '';
        this.type = data?.type ?? '';
        this.vendorName = data?.vendorName ?? data?.expertVendorName ?? data?.lastAssignationVendorName ?? '';
    }
}
